import axios from 'axios';
import { ethers } from 'ethers';
import { COINGECKO_API_URL, PROVIDER } from '../constants/constants';

export const fetchUsdBalance = async (
  wallet: string,
): Promise<string | undefined> => {
  try {
    const balance = await PROVIDER.getBalance(wallet);
    const bnbBalance = parseFloat(ethers.formatEther(balance));

    try {
      const response = await axios.get(COINGECKO_API_URL);
      const bnbUsdPrice = response.data?.binancecoin?.usd;

      if (bnbUsdPrice) {
        const formattedBalance = (bnbBalance * bnbUsdPrice).toFixed(2);
        return formattedBalance;
      } else {
        console.error('Invalid response for BNB price');
      }
    } catch (error) {
      console.error('Error fetching BNB price:', error);
      throw error;
    }
  } catch (error) {
    console.error('Error fetching wallet balance:', error);
    throw error;
  }
};
